export default "__VITE_ASSET__8dd4f96f__"